module.exports = __webpack_public_path__ + "img/ad.f07f4ebc.svg";